<template>
  <div>
    <h1 class="title has-text-centered">Iniciar</h1>
    <div class="judges--officials">
      <h2 class="subtitle is-5 has-text-centered">Oficiales de Lección</h2>
      <div class="has-text-centered" style="margin-top: -1.25em;">
        <span v-for="(judges, index) in judgesExecution"
              :key="index"
              style="padding-right: 1.5rem"
        >
        <template v-if="judges && judges.judge && judges.secretary">
          {{ `${judges.judge.name} ${judges.judge.lastname} / ${judges.secretary.name} ${judges.secretary.lastname}` }}
        </template>
        <template v-else-if="judges && judges.judge">
          {{ `${judges.judge.name} ${judges.judge.lastname}` }}
        </template>
      </span>
      </div>

    </div>
    <hr>
    <b-notification v-if="!judgeIsOfficial" aria-close-label="Close notification" type="is-primary">
      <p style="color: #424242">Usted <b>no es juez oficial</b>, si selecciona <b>"Evaluar con mi usuario"</b> las notas no serán consideradas dentro de la calificación final del jinete.</p>
    </b-notification>
    <div class="columns is-vcentered is-centered">
      <div v-if="!judgeIsOfficial"
        class="column is-4">
        <div :class="['card pointer-element', {'is-active-card': optionSelected == 'unofficial'}]" @click="optionSelected = 'unofficial'">
          <div class="card-content has-text-centered">
            <b-icon icon="account-outline" size="is-large"></b-icon>
            <h1 class="title is-5 has-text-centered">Evaluar con mi usuario</h1>
            <h2 class="subtitle is-6 has-text-centered">Las notas se registrarán a tu cuenta</h2>
            <div v-if="optionSelected === 'unofficial'"
              class="is-centered" style="margin-top: 10px;"
            >
              <b-button type="is-primary" size="is-medium" :loading="isLoading" @click="startEvaluation" expanded>Iniciar Evaluación</b-button>
            </div>
          </div>
        </div>
      </div>
      <div  class="column is-4">
        <div :class="['card pointer-element', {'is-active-card': optionSelected == 'official'}]" @click="optionSelected = 'official'">
          <div class="card-content has-text-centered">
            <b-icon icon="account-supervisor-outline" size="is-large"></b-icon>
            <h1 class="title is-5 has-text-centered">Evaluar como Oficial</h1>
            <h2 class="subtitle is-6 has-text-centered">Las notas serán registradas a la cuenta del juez y secretario seleccionado</h2>
            <div v-if="optionSelected === 'official'">
              <b-field>
                <b-select v-model="selectedJudge" size="is-medium" placeholder="Selecciona los evaluadores" :disabled="!canSelectJudge" expanded>
                  <template v-for="(judges, index) in judgesExecution">
                    <option  :value="judges" :key="`judge-${index}`">
                      <span v-if="judges.judge">{{ `${judges.judge.name} ${judges.judge.lastname}` }}</span>
                      <span v-if="judges.secretary">{{ ` / ${judges.secretary.name} ${judges.secretary.lastname}` }}</span>
                    </option>
                  </template>
                </b-select>
              </b-field>
              <div class="is-centered" style="margin-top: 10px;">
                  <b-button type="is-primary" size="is-medium" :loading="isLoading" @click="startEvaluation" :disabled="!selectedJudge" expanded>Iniciar Evaluación</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import EventService from '@/services/ExerciseService'

import ExecutionService from '@/services/ExecutionService'
import EventService from '@/services/EventService'
import CredentialsService from '@/services/CredentialsService'

export default {
  props: {
    eventId: {
      required: true
    },
    executionId: {
      required: true
    },
    judgesExecution: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedJudge: null,
      isLoading: false,
      optionSelected: null,
      judgeIsOfficial: null
    }
  },
  created () {
    this.setUserIsOfficial()
  },
  computed: {
    canSelectJudge () {
      return CredentialsService.hasPermission('execution.select-judge')
    },
    user () {
      return CredentialsService.getUser()
    },
    userCurrentJudge () {
      if (this.judgeIsOfficial) {
        return this.judgesExecution.filter((item) => item.judge_id === this.user.id || item.secretary_id === this.user.id)[0]
      }
      return null
    }
  },
  mounted () {
    this.setUserIsOfficial()
  },
  methods: {
    async startEvaluation () {
      this.isLoading = true
      if (this.optionSelected === 'official') {
        await ExecutionService.updateExecution(this.eventId, this.executionId, { 'execution_status_id': 2 })
        await ExecutionService.updateJudgeExecution(this.executionId, this.selectedJudge.id, { 'status_id': 2 })
        await EventService.updateEvent(this.eventId, { 'event_status_id': 2 })
        this.$emit('start-evaluation', this.selectedJudge)
      } else if (this.optionSelected === 'unofficial') {
        await ExecutionService.updateExecution(this.eventId, this.executionId, { 'execution_status_id': 2 })
        this.$emit('start-evaluation', this.selectedJudge)
      }
      this.isLoading = false
    },
    async setUserIsOfficial () {
      this.judgeIsOfficial = await this.judgesExecution.some((item) => item.judge_id === this.user.id || item.secretary_id === this.user.id)
      if (this.judgeIsOfficial) {
        this.optionSelected = 'official'
        this.selectedJudge = this.userCurrentJudge
      }
    }
  },
  watch: {
    optionSelected (value) {
      if (value === 'unofficial') {
        this.selectedJudge = {
          judge: this.user,
          judge_id: this.user.id,
          secretary_id: this.user.id,
          secretary: this.user,
          official: this.judgeIsOfficial
        }
      } else {
        this.selectedJudge = this.userCurrentJudge
      }
    },
    judgesExecution () {
      this.setUserIsOfficial()
    }
  }
}
</script>

<style >
  .pointer-element:hover {
    cursor: pointer !important;
    border: 1px solid #FF9800 !important;
  }

  .is-active-card {
    border: 1px solid #FF9800 !important;
    background-color: #f8f8f8 !important;
  }

</style>
